// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2508":"e6d76d5c","2808":"e6d76d5c","5713":"768c870d","8140":"31d6cfe0"}[chunkId] + ".css";
};